import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import L from "leaflet";
import "leaflet-iconmaterial";
import { useEffect, useMemo, useRef } from "react";
import ReactDOMServer from "react-dom/server";
import { useTranslation } from "react-i18next";
import { Marker, Popup } from "react-leaflet";
import { useActualPlaceholder } from "Utils/hooks";
import LeafletMarker from "./LeafletMarker";

//maker leaflet déplaçable
const DraggableMarker = ({ position, marker, id, parentId }) => {
  const { t } = useTranslation();
  const { setPosition, activePlaceholderId, set, data } =
    useActualPlaceholder(parentId);
  const draggable = useMemo(
    () => activePlaceholderId === id,
    [activePlaceholderId]
  );
  const markerRef = useRef(null);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          // setMapPosition(marker.getLatLng());
          const { lat, lng } = marker.getLatLng();
          setPosition({ x: lng, y: lat, z: 0 });
          marker.openPopup();
        }
      },
      dblclick() {
        const marker = markerRef.current;
        if (marker != null) {
          // setMapPosition(marker.getLatLng());
          set(draggable ? null : id);
        }
      },
    }),
    [activePlaceholderId, draggable]
  );

  useEffect(() => {
    draggable && markerRef.current.openPopup();
  }, [draggable]);

  useEffect(()=> {
    
    const { lat, lng } = markerRef?.current?.getLatLng();
    markerRef?.current?.setLatLng({ lat, lng });
  }, [marker?.scale])

  return (
    <Marker
      draggable={draggable}
      eventHandlers={eventHandlers}
      position={[position?.y, position?.x]}
      ref={markerRef}
      icon={L.divIcon({
        className: "custom icon",
        html: ReactDOMServer.renderToString(
          <LeafletMarker {...marker} draggable={draggable} />
        ),
      })}
    >
      {draggable && (
        <Popup open>
          <Box sx={{ padding: 2, width: "max-content", maxWidth: "20dvw" }}>
            <Typography textAlign="center" style={{margin: 0}}>
              {t("/leafleteditor.createlayer.draggable_instruction")}{" "}
            </Typography>
          </Box>
        </Popup>
      )}
    </Marker>
  );
};

export default DraggableMarker;
